var _path, _rect, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 9.16683V6.41683C18.3333 5.40431 17.5125 4.5835 16.5 4.5835H4.58333C3.57081 4.5835 2.75 5.40431 2.75 6.41683V15.5835C2.75 16.596 3.57081 17.4168 4.58333 17.4168H16.5C17.5125 17.4168 18.3333 16.596 18.3333 15.5835V12.8335",
    stroke: "current",
    strokeWidth: 1.83333
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.833,
    y: 8.25,
    width: 7.33333,
    height: 5.5,
    rx: 1.83333,
    stroke: "current",
    strokeWidth: 1.83333
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4997,
    cy: 11.0002,
    r: 0.458333,
    stroke: "current",
    strokeWidth: 0.916667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.d5a996a799f71546883fbcf0137a4a9d.svg";
export { ForwardRef as ReactComponent };